import { useEffect, useMemo } from "react";
import { IS_IFRAMES, PATH_CUSTOMER_ID } from "../constants";

// “Iframe” 模式自定义配置，若未配置均显示“zeitro”相关的默认设置
const CONFIG = Object.entries({
  // customer id
  megacapital: {
    // 浏览器 标签页的tab的图标
    favicon: "MegaCapital.png",
    // 浏览器 标签tab的名称
    title: "MCFUNDING | Mortgage GPT",
    // 左上角、登陆、注册弹窗logo
    logo: "MegaCapital_icon.png",
    // 登陆、弹窗的 联系邮箱
    email: "",
    // 用户点击logo打开的地址
    url: "https://mcfunding.com",
    // 登录、注册弹窗 左侧的baner图片
    // modalbaner: "",
    // 用户是否隐藏 agency guideline， scenario desk两种mode都需要
    // hideModeToggle: false,
  },
  googain: {
    favicon: "Googain.png",
    title: "Googain | Mortgage GPT",
    logo: "Googain_icon.png",
    email: "",
    url: "https://googain.com",
  },
  greenbox: {
    favicon: "Greenbox.png",
    title: "Greenbox Loans| Mortgage GPT",
    logo: "Greenbox_icon.svg",
    email: "",
    url: "https://greenboxloans.com",
    hideModeToggle: true, // Iframe模式， Greenbox 不需要展示
  },
  newwave: {
    modalbaner: 'iframe_baner.png'
  },
  newfi: {
    modalbaner: 'iframe_baner.png'
  },
  nationsdirect: {
    modalbaner: 'iframe_baner.png'
  },
  successlending: {
    modalbaner: 'iframe_baner.png'
  },
  nationwide: {
    modalbaner: 'iframe_baner.png'
  },
  latopbrokerinc: {
    favicon: "LaTopBroker.png",
    title: "LA Top Broker | Mortgage GPT",
    logo: "LaTopBroker.png",
    email: "",
    url: "https://latopbroker.com",
  },
  iservelending: {
    hideModeToggle: true,
  },
  flipsidelendingllc: {
    hideModeToggle: true,
  },
  homesteadfundingcorp:{
    hideModeToggle: true,
  }
});

CONFIG.forEach(([_k, v]) => {
  if(v.logo) v.logo = `/lender_icon/${v.logo}`;
  if(v.favicon) v.favicon = `/lender_icon/${v.favicon}`;
  if(v.modalbaner) v.modalbaner = `/lender_icon/${v.modalbaner}`;
});

/**
 * @name useIframeConfig 获取 “Iframe” 模式下，自定义 logo 等配置
 * @description 除了已配置的（CONFIG）“customer id” 其他还是用 “zeitro” 默认的胚子
 */
export default function useIframeConfig() {
  const config = useMemo(
    () =>
      IS_IFRAMES
        ? CONFIG.find(([k]) => PATH_CUSTOMER_ID?.includes(k))?.[1]
        : undefined,
    [],
  );

  useEffect(() => {
    if (!config) return;
    let link = document.querySelector<HTMLLinkElement>("link[rel*='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = config.favicon;
    if (config.title) {
      setTimeout(() => {
        document.title = config.title;
      });
    }
  }, [config]);

  return config;
}
